export type FetchResult<T> = { success: true; data: T } | { success: false; errors: string[] };

export const COUNTRY = {
  NORWAY: 'Norway',
  SWEDEN: 'Sweden',
  FINLAND: 'Finland',
  GERMANY: 'Germany',
  SPAIN: 'Spain',
} as const;

export type Country = (typeof COUNTRY)[keyof typeof COUNTRY];

export const RESOLUTION = {
  HOUR: 'Hour',
  DAY: 'Day',
  WEEK: 'Week',
  MONTH: 'Month',
  YEAR: 'Year',
  QUARTER: 'Quarter',
} as const;

export type Resolution = (typeof RESOLUTION)[keyof typeof RESOLUTION];

export const CURRENCY = { NOK: 'NOK', SEK: 'SEK', EUR: 'EUR' } as const;

export type Currency = (typeof CURRENCY)[keyof typeof CURRENCY];

export const PRICE_UNIT = { NOK: 'øre/kWh', SEK: 'öre/kWh', EUR: '€/MWh' } as const;

export type PriceUnit = (typeof PRICE_UNIT)[keyof typeof PRICE_UNIT];

export type ChartValue = {
  xIndex: number;
  yValue: number | null;
  toDate: string;
  readingDate: string;
};

export type ChartResponse = {
  seriesDescription: string | null;
  seriesName: string | null;
  resolution: Resolution;
  unit: string | null;
  seriesType: string | null;
  stack: number;
};

export type ChartWithValues = ChartResponse & { values: ChartValue[] };

export type KpiRequest = { meterPointIds: string[] | undefined };

export type NotFoundResponse = { title: string; status: 404; detail: string; instance: string };

export type EmailRequiredResponse = { message: 'Email is required' };
